
import tidalDropdown from '@tidal/styles-dropdown';
import tidalIcon from '@tidal/styles-icons';

export default {
    filters: {
        /**
         * @param {Array<{name: string, value: string}>} langOptions
         * @param {Array<string>} availableLangs
         */
        getSupported(langOptions, availableLangs) {
            const newLangOptions = langOptions.filter(function(lang) {
                return availableLangs.indexOf(lang.value) > -1;
            });
            return newLangOptions;
        },
    },
    components: {
        tidalDropdown,
        tidalIcon,
    },
    props: {
        currentLang: {
            type: String,
            required: true,
        },
        availableLangs: {
            type: Array,
            required: true,
        },
        reversed: {
            type: Boolean,
            default: true,
        },
        navigateOnPick: {
            type: Boolean,
            default: true,
        },
        setCookie: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            languageSwitcherOptions: [
                { name: 'English', value: 'en' },
                { name: 'Български', value: 'bg' },
                { name: 'Český ', value: 'cs' },
                { name: 'Deutsch', value: 'de' },
                { name: 'Español', value: 'es' },
                { name: 'Français', value: 'fr' },
                { name: 'Hrvatski', value: 'hr' },
                { name: 'Italiano', value: 'it' },
                { name: '日本語', value: 'ja' },
                { name: 'Norsk', value: 'no' },
                { name: 'Polski', value: 'pl' },
                { name: 'Português', value: 'pt' },
                { name: 'Português (Brasil)', value: 'pt-BR' },
                { name: 'Slovenščina', value: 'sl' },
                { name: 'Srpski', value: 'sr' },
            ],
        };
    },
    computed: {
        /** @returns {{name: string, value: string} | undefined} */
        currentLangObj() {
            return this.languageSwitcherOptions
                .find(lang => lang.value.toLowerCase() === this.currentLang.toLowerCase());
        },
        /** @returns {string} */
        ariaLabel() {
            let label = 'Language switcher.';
            if (this.currentLangObj) {
                label += ' ' + this.currentLangObj.name + '.';
            }

            return label;
        },
        globeIcon() {
            return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.4" fill="none" stroke="#fff" stroke-width="1.2"/><path d="M4.3437 1.55172C3.73696 1.55172 3.3523 1.91802 2.13881 3.2069C1.93656 3.41639 1.92097 3.77071 2.32547 3.77071C2.72996 3.77071 2.32547 4.86129 2.52772 5.85273C2.72996 6.84417 4.24683 7.73647 4.04458 7.53818C3.84233 7.33989 3.64008 6.54674 4.24683 7.1416C4.85357 7.73647 5.66256 8.62876 6.16818 8.82705C6.6738 9.02534 7.58392 8.82705 7.58392 9.22363C7.58392 9.6202 8.59516 10.1159 9.10078 10.3142C9.6064 10.5125 8.89853 10.8099 8.69629 11.3057C8.49404 11.8014 9.6064 13.2885 9.90977 13.6851C10.2131 14.0817 10.4154 14.1808 10.0109 14.974C9.6873 15.6085 10 14.9051 10 15.5C13.2469 13.6851 13.2877 13.3966 14.8081 11.4828C14.3016 11.1641 13.348 11.2065 13.2469 10.8099C13.1457 10.4134 12.6401 10.4134 12.1345 10.0168C11.6289 9.6202 10.8199 9.71935 10.2131 9.71935C9.6064 9.71935 9.10078 9.81849 8.89853 9.71935C8.69629 9.6202 8.59516 9.22363 8.39291 8.82705C8.19067 8.43048 8.08954 8.62876 7.78617 8.52962C7.4828 8.43048 7.88729 8.13304 7.78617 7.93476C7.68504 7.73647 7.38167 7.93476 7.38167 8.13304C7.38167 8.33133 6.37043 8.13304 6.37043 7.24075C6.37043 6.34845 7.38167 6.64588 8.08954 6.54674C8.79741 6.4476 8.59516 7.33989 8.89853 7.24075C9.20191 7.1416 9.20191 6.74503 9.10078 6.34845C8.99966 5.95188 9.6064 5.5553 9.90977 4.86129C10.2131 4.16728 11.9323 4.86129 11.5278 4.46472C11.1233 4.06814 11.1233 3.86985 11.9323 3.77071C12.7413 3.67156 11.4266 2.97756 10.8199 2.68012C10.2131 2.38269 8.89853 2.87841 8.29179 2.97755C7.68504 3.0767 6.87605 2.68012 6.97718 2.08526C7.0783 1.49039 10.0109 1.98611 10.4154 2.08526C10.8199 2.1844 11.1233 1.98611 10.4154 1.39128C9.70753 0.796437 8.08954 1.39128 7.38167 1.09386C6.6738 0.796436 6.6738 1.29213 5.56144 1.39128C4.79273 1.45979 4.97003 1.55172 4.3437 1.55172Z" fill="#fff"/></svg>';
        },
    },
    methods: {
        /** @param {string} lang */
        setLang(lang) {
            if (this.setCookie) {
                const age_30_days = 60 * 60 * 24 * 30;
                const options = location.protocol === 'https' ? ' SameSite=None; Secure' : '';
                document.cookie = `app_lang=${lang}; domain=tidal.com; path=/; max-age=${age_30_days};${options}`;
            }

            if (this.navigateOnPick) {
                const location = window.location.href;
                if (this.setCookie) {
                    return window.location.href = location;
                }

                const langRegexp = /(\?|&)lang=[a-z-]+/i;
                if (location.match(langRegexp)) {
                    window.location.href = location.replace(langRegexp, '$1lang=' + lang);
                } else {
                    const hasQuestionMark = location.indexOf('?') !== -1;
                    window.location.href = `${location}${hasQuestionMark ? '&' : '?'}lang=${lang}`;
                }
            }

            this.$emit('picked', lang);
        },
    },
};
